import { render, staticRenderFns } from "./APIRequest.vue?vue&type=template&id=42b477cb&"
import script from "./APIRequest.vue?vue&type=script&lang=ts&"
export * from "./APIRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports